import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=fefa692a&"
import script from "./CourseCreate.vue?vue&type=script&lang=js&"
export * from "./CourseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports